import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback } from 'react';
import { View } from 'react-native';
import { component, PressableButtonView, SmallView, H1View, AnimatedScrollView, BaseScreenComponent, ContainerView } from '@serviceos-rn/core';
import { TipConfig } from '../../../TipConfig';
import { TipRoutes } from '../../Coordinator/TipRoutes';
import { ITipScreenViewModelType } from './ITipScreenViewModel';
import { TipConfiguration } from '../../../Domain/DTOs/TipConfigurationDTO';
import { HeaderView } from '../../Components/Header/Header';
import { OptionsView } from '../../Components/Options/OptionsView';
import { useTipHeight } from '../../Hooks/UseTipHeight';
import { useFlex } from '../../Hooks/UseFlex';
export const NormalTipScreenComponent = component({
    provider: TipConfig.provider,
    moduleName: TipConfig.moduleName,
    componentName: TipConfiguration.ComponentNames.normalTipScreen,
    dependencies: {
        viewModel: ITipScreenViewModelType
    },
    style(theme, mediaQuery) {
        return {
            container: {
                flex: 1,
                alignItems: 'center'
            },
            shell: Object.assign({ width: '100%', height: '100%' }, mediaQuery.md({
                maxWidth: 500
            })),
            root: {
                flex: 1,
                width: '100%',
                height: '100%',
            },
            body: {
                flex: 2,
                alignItems: 'center',
                paddingTop: 20
            },
            footer: {
                justifyContent: 'flex-end'
            },
            title: {
                textAlign: 'center',
                marginBottom: 42
            },
            description: {
                textAlign: 'center',
                marginBottom: 42
            },
            content: {},
        };
    }
})(({ style, viewModel, navigation, route }) => {
    var _a, _b, _c;
    const [_, setHeight] = useTipHeight((route === null || route === void 0 ? void 0 : route.name) || TipRoutes.TipNormal);
    const [flex] = useFlex();
    const handleLaylout = useCallback((e) => {
        setHeight(e.nativeEvent.layout.height);
    }, []);
    return (_jsx(BaseScreenComponent, { navigation: navigation, loading: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.loading, onErrorDismiss: viewModel === null || viewModel === void 0 ? void 0 : viewModel.onErrorDismiss, errorPopUp: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.error, hideHeader: true, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.container, children: _jsx(AnimatedScrollView, { containerStyle: style === null || style === void 0 ? void 0 : style.shell, contentContainerStyle: flex && { minHeight: '100%' }, extraHeight: 100, children: _jsx(View, { style: style === null || style === void 0 ? void 0 : style.root, onLayout: handleLaylout, children: _jsxs(ContainerView, { children: [_jsx(HeaderView, { units: (viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.units) || [] }), _jsx(View, { style: style === null || style === void 0 ? void 0 : style.body, children: _jsxs(View, { style: style === null || style === void 0 ? void 0 : style.content, children: [_jsx(H1View, { textStyle: style === null || style === void 0 ? void 0 : style.title, children: (_a = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions) === null || _a === void 0 ? void 0 : _a.title }), !!((_b = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions) === null || _b === void 0 ? void 0 : _b.description) && (_jsx(SmallView, { textStyle: style === null || style === void 0 ? void 0 : style.description, children: (_c = viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions) === null || _c === void 0 ? void 0 : _c.description })), _jsx(OptionsView, { tipOptions: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.tipOptions, onChange: viewModel === null || viewModel === void 0 ? void 0 : viewModel.onChange, onSubmit: viewModel === null || viewModel === void 0 ? void 0 : viewModel.submit })] }) }), _jsx(View, { style: style === null || style === void 0 ? void 0 : style.footer, children: viewModel === null || viewModel === void 0 ? void 0 : viewModel.viewData.interactions.map(interaction => (_jsx(PressableButtonView, Object.assign({}, interaction), interaction.action))) })] }) }) }) }) }));
});
